import { useState } from "react";
import {
  ErrorMessage,
  inputContainerStyle,
  InputStyled,
} from "../../Components/ui/Forms/contactForm";
import VisibilityIconComp, {
  PasswordWrapper,
} from "../../Components/ui/Forms/FormComponents/Visibility";
import { useTheme } from "../../context/ThemeContext";
import { PasswordInputProps } from "../../Components/common/types";

const PasswordInput = <T,> ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  onBlurWrapper,
  error,
}: PasswordInputProps<T>) => {

  const [inputFocusHover, setInputFocusHover] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
    const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  //password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  //Handle focus and hover state of the InputStyled
  const handleFocusHoverState = (state: boolean) => {
    setInputFocusHover(state);
  };

  return (
    <div style={inputContainerStyle}>
      <label htmlFor={id}>{label}</label>
      <PasswordWrapper>
        <InputStyled
          type={passwordVisible ? "text" : "password"}
          id={id}
          autoComplete="new-password"
          name={String(name)}
          placeholder={placeholder}
          value={value}
          onChange={onChange}

          onBlur={() => {
            handleFocusHoverState(false);
            if (onBlurWrapper) onBlurWrapper(name, value);
          }}

          onFocus={() => handleFocusHoverState(true)}
          onMouseEnter={() => handleFocusHoverState(true)}
          onMouseLeave={() => handleFocusHoverState(false)}

          $errorColor={error ? "red" : ""}
          $hoverBacColor="transparent"
          $color="inherit"
          $hoverColor="inherit"
        />
        <VisibilityIconComp
          isDarkMode={isDarkMode}
          passwordVisible={passwordVisible}
          togglePasswordVisibility={togglePasswordVisibility}
          isHoveredOrFocused={inputFocusHover}
        />
      </PasswordWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default PasswordInput;